export default __webpack_public_path__ + "static/media/search.c59af436.svg";